/**
 * Detects environment from hostname
 */
export const getEnvironment = () => {
    try {
      const host = window.location.hostname;
      if (host.includes('localhost')) return 'local';
      if (host.includes('staging')) return 'staging';
      if (host.includes('dev')) return 'development';
      return 'production';
    } catch (error) {
      console.error('Failed to detect environment:', error);
      return 'unknown';
    }
  };